/* 
Registers all of our globally registered "common" components and installs vue plug-ins
such as the router and vuetify.

Our naming convention for our globally registered components is that they start with "Our".
(Other components that aren't widely used should be imported specifically where required.)
*/
import "babel-polyfill";
import Vue from "vue";
import Router from "vue-router";
import App from "@/App.vue";
import Vuetify from "vuetify";
import VueClipboard from "vue-clipboard2";
import store from "@/store";
import { router } from "@/router";
import "@/scss/main.scss";
import "@/helpers/draggable.dialog.js";
import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";

// because IE11 doesn't support css variables (custom properties)
import cssVarsPonyFill from "css-vars-ponyfill/dist/css-vars-ponyfill";

// our common components
import OurActionButton from "@/components/common/OurActionButton.vue";
import OurActionsBar from "@/components/common/OurActionsBar.vue";
import OurBusyIndicator from "@/components/common/OurBusyIndicator.vue";
import OurChartIsEmptyPlaceholder from "@/components/common/chart/OurChartIsEmptyPlaceholder.vue";
import OurConfirmationDialog from "@/components/common/OurConfirmationDialog.vue";
import OurCurrencyInput from "@/components/common/OurCurrencyInput.vue";
import OurDataContainer from "@/components/common/OurDataContainer.vue";
import OurDataField from "@/components/common/OurDataField.vue";
import OurDatePicker from "@/components/common/OurDatePicker.vue";
import OurDateTimePicker from "@/components/common/OurDateTimePicker.vue";
import OurEmptyTabMessage from "@/components/common/OurEmptyTabMessage.vue";
import OurExpanderRow from "@/components/common/table/OurExpanderRow.vue";
import OurExpandIcon from "@/components/common/OurExpandIcon.vue";
import OurFavouriteButton from "@/components/common/OurFavouriteButton.vue";
import OurFileUploadInput from "@/components/common/OurFileUploadInput.vue";
import OurHeading from "@/components/common/OurHeading.vue";
import OurIconButton from "@/components/common/OurIconButton.vue";
import OurGettingStartedHint from "@/components/common/OurGettingStartedHint.vue";
import OurLoadingIndicator from "@/components/common/OurLoadingIndicator.vue";
import OurLookupsList from "@/components/common/OurLookupsList.vue";
import OurMultilineText from "@/components/common/OurMultilineText.vue";
import OurNavCol from "@/components/common/table/OurNavCol.vue";
import OurNextPreviousNavigator from "@/components/common/OurNextPreviousNavigator.vue";
import OurPercentageInput from "@/components/common/OurPercentageInput.vue";
import OurQuickSearch from "@/components/common/table/OurQuickSearch.vue";
import OurSearchButton from "@/components/common/table/OurSearchButton.vue";
import OurSavedSearchesMenu from "@/components/common/table/OurSavedSearchesMenu.vue";
import OurSimpleTableHeader from "@/components/common/table/OurSimpleTableHeader.vue";
import OurSearchBar from "@/components/common/table/OurSearchBar.vue";
import OurTableBusyIndicator from "@/components/common/table/OurTableBusyIndicator.vue";
import OurTableHeader from "@/components/common/table/OurTableHeader.vue";
import OurTableFooter from "@/components/common/table/OurTableFooter.vue";
import OurUserGuideButton from "@/components/common/OurUserGuideButton.vue";
import OurRequiredFieldIndicator from "@/components/common/OurRequiredFieldIndicator.vue";
import OurValidationDialog from "@/components/common/OurValidationDialog.vue";
import OurWarningChips from "@/components/common/OurWarningChips.vue";
import OurWarningsTooltip from "@/components/common/OurWarningsTooltip.vue";
import OurWidgetToolbar from "@/components/common/OurWidgetToolbar.vue";

// our layouts
import LayoutForAnonymous from "@/views/layout/Anonymous.vue";
import LayoutForStaff from "@/views/layout/Staff.vue";
import LayoutForRedirection from "@/views/layout/Redirection.vue";
import LayoutForLevyEstimator from "@/views/layout/LevyEstimator.vue";

Vue.component("our-action-button", OurActionButton);
Vue.component("our-actions-bar", OurActionsBar);
Vue.component("our-busy-indicator", OurBusyIndicator);
Vue.component("our-search-bar", OurSearchBar);
Vue.component("our-chart-is-empty-placeholder", OurChartIsEmptyPlaceholder);
Vue.component("our-confirmation-dialog", OurConfirmationDialog);
Vue.component("our-currency-input", OurCurrencyInput);
Vue.component("our-data-container", OurDataContainer);
Vue.component("our-data-field", OurDataField);
Vue.component("our-date-picker", OurDatePicker);
Vue.component("our-date-time-picker", OurDateTimePicker);
Vue.component("our-empty-tab-message", OurEmptyTabMessage);
Vue.component("our-expander-row", OurExpanderRow);
Vue.component("our-expand-icon", OurExpandIcon);
Vue.component("our-favourite-button", OurFavouriteButton);
Vue.component("our-file-upload-input", OurFileUploadInput);
Vue.component("our-heading", OurHeading);
Vue.component("our-icon-button", OurIconButton);
Vue.component("our-getting-started-hint", OurGettingStartedHint);
Vue.component("our-loading-indicator", OurLoadingIndicator);
Vue.component("our-lookups-list", OurLookupsList);
Vue.component("our-multiline-text", OurMultilineText);
Vue.component("our-nav-col", OurNavCol);
Vue.component("our-next-previous-navigator", OurNextPreviousNavigator);
Vue.component("our-percentage-input", OurPercentageInput);
Vue.component("our-quick-search", OurQuickSearch);
Vue.component("our-search-button", OurSearchButton);
Vue.component("our-saved-searches-menu", OurSavedSearchesMenu);
Vue.component("our-simple-table-header", OurSimpleTableHeader);
Vue.component("our-table-busy-indicator", OurTableBusyIndicator);
Vue.component("our-table-footer", OurTableFooter);
Vue.component("our-table-header", OurTableHeader);
Vue.component("our-user-guide-button", OurUserGuideButton);
Vue.component("our-required-field-indicator", OurRequiredFieldIndicator);
Vue.component("our-validation-dialog", OurValidationDialog);
Vue.component("our-warning-chips", OurWarningChips);
Vue.component("our-warnings-tooltip", OurWarningsTooltip);
Vue.component("our-widget-toolbar", OurWidgetToolbar);

Vue.component("layout-for-anonymous", LayoutForAnonymous);
Vue.component("layout-for-staff", LayoutForStaff);
Vue.component("layout-for-redirection", LayoutForRedirection);
Vue.component("layout-for-levy-estimator", LayoutForLevyEstimator);

Vue.config.productionTip = false;
Vue.use(Vuetify, {
  theme: {
    primary: "#16A086",
    secondary: "#303641",
    accent: "#EDEDED",
    error: "#E63939"
  },
  options: {
    customProperties: true
  }
});

Vue.use(Router);
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(mavonEditor);
Vue.use(cssVarsPonyFill);

new Vue({
  el: "#vue-app",
  router,
  store,
  render: h => h(App)
});
